import { PropsWithChildren, createContext, useContext } from 'react';

type SSRLoginStateContextType = {
	hasCloudSessionTokenCookie: boolean;
	userAgent?: string;
};

const SSRLoginStateContext = createContext<SSRLoginStateContextType>({
	hasCloudSessionTokenCookie: false,
});

export const useSSRLoginState = () => {
	const context = useContext(SSRLoginStateContext);
	if (!context) {
		throw new Error('useSSRLoginState must be used within SSRLoginStateProvider');
	}
	return context;
};

type SSRLoginStateProviderProps = PropsWithChildren & {
	hasCloudSessionTokenCookie?: boolean;
	userAgent?: string;
};

export const SSRLoginStateProvider = ({
	children,
	hasCloudSessionTokenCookie = false,
	userAgent,
}: SSRLoginStateProviderProps) => {
	return (
		<SSRLoginStateContext.Provider value={{ hasCloudSessionTokenCookie, userAgent }}>
			{children}
		</SSRLoginStateContext.Provider>
	);
};
